import { useForm } from 'react-hook-form';
import { FormRendererAPIType, RawFormComponentType } from 'components/common/form';
import { prepareFormElementProps } from 'components/common/form/formTools';
import ReactHookFormController from 'components/common/form/layout/ReactHookFormController';
import React, { useEffect } from 'react';

interface ITextTinyMCEVariable {
    value: string;
    name: string;
    onChange: (value: string) => void;
}

export default function TextTinyMCEVariable({ value, name, onChange }: ITextTinyMCEVariable) {
    const {
        setValue: hookFormSetValue,
        control,
        getValues: hookFromGetValues,
        watch,
    } = useForm({
        defaultValues: {
            text: value,
        },
    });
    const formActions = {
        hookFormControl: control,
        hookFormGetValues: hookFromGetValues,
        hookFormSetValue: hookFormSetValue,
        hookFormWatch: watch,
        formDidMount: true,
    } as FormRendererAPIType;

    const textValue = watch('text');

    useEffect(() => {
        onChange(textValue);
    }, [textValue]);

    const tinyMCEProps = {
        form: formActions,
        component: {
            component: 'FormTinyMCE',
            name: 'text',
            props: {
                value,
            },
        } as RawFormComponentType,
    };

    return <ReactHookFormController elementProps={prepareFormElementProps(tinyMCEProps)}></ReactHookFormController>;
}
